/**
 * A callback you can use as the onError argument of the
 * useForm() composable. It sets global errors below the
 * last field.
 */
export function handleError({ error, setFieldError, form }) {
  const messagesMap = {
    'Incorrect current password': [
      {
        message: 'Incorrect current password',
        field: 'current_password',
      },
    ],
    'New password must be different from the current password': [
      {
        message: 'New password must be different from the current password',
        field: 'new_password',
      },
      {
        message: 'New password must be different from the current password',
        field: 'new_password_confirmation',
      },
    ],
  }
  if (messagesMap[error.data.message]?.length > 0) {
    messagesMap[error.data.message]?.forEach(({ message, field }) => {
      setFieldError(field, message)
    })
  } else {
    const lastField = Object.keys(form).pop()
    setFieldError(lastField, error.data.message)
  }
}
